import path from './pieces/path';
import growth from './pieces/growth';


const musings = [

    {
        key: 2,
        title: "On Growth",
        date: "apr 5, 2021",
        time: "2 min",
        subheading: "Like an endlessly unfurling leaf.",
        text: growth
    },

    {
        key: 1,
        title: "Defining Your Own Path",
        date: "jan 30, 2021",
        time: "5 min",
        subheading: "Disclaimer: Not a tutorial on making your own $PATH variable.",
        text: path
    },

];

export default musings;